export const ru = {
    'invite-call-link-title': 'Ссылка для присоединения к звонку',
    'invite-call-link-hint': 'Вы можете отправить эту ссылку любому человеку, в том числе и не сотруднику Яндекса. Когда звонок будет создан, участник сможет по этой ссылке присоединиться к звонку через браузер',
    'invite-call-link-copy-success': 'Ссылка для присоединения к звонку скопирована',
    'copy-invite-call-link-title': 'Скопировать ссылку',
    'regenerate-invite-call-link': 'Перегенерировать ссылку',
}
